import React from "react";
import styled from "styled-components";

const TidalInfoTagWrapper = styled.div<{ isActive: boolean }>`
  height: 26px;
  border-radius: 74px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: ${(props) => props.theme.colors.tags[5]};
  @media only screen and (max-width: 580px) {
    padding: 0 8px;
  }
  p {
    font-size: 14px;
    font-weight: 600;
    @media only screen and (max-width: 580px) {
      font-size: 10px;
    }
    @media only screen and (max-width: 370px) {
      font-size: 8px;
    }
    color: ${(props) =>
      props.isActive ? props.theme.colors.text[1] : props.theme.colors.text[0]};
  }
`;

interface ITidalInfoTag {
  isActive: boolean;
  text: string;
}

const TidalInfoTag = ({ isActive, text }: ITidalInfoTag): JSX.Element => {
  return (
    <TidalInfoTagWrapper isActive={isActive}>
      <p>{text}</p>
    </TidalInfoTagWrapper>
  );
};

export default TidalInfoTag;
